import React from 'react';
import './LatestCampaigns.scss';
import { NEWS_LIST_FILTER } from '../News/getNews';

const LatestCampaigns = () => {
  // Slice top 5 latest campaigns
  const latestCampaigns = NEWS_LIST_FILTER.slice(0, 5);

  return (
    <div className="od-home__latest-campaigns">
      <div className="od-home__latest-campaigns-container">
        <h2 className="od-home__latest-campaigns-heading">Latest Campaigns</h2>
        {latestCampaigns?.length > 0 && (
          <ul className="od-home__latest-campaigns-list">
            {latestCampaigns.map((campaign, index) => (
              <li
                key={campaign?.title}
                className="od-home__latest-campaigns-item"
                data-datetime={campaign?.datetime}
                onClick={() => (campaign?.slug ? window.location.assign(campaign.slug) : {})}
              >
                <img alt={campaign?.title} loading="lazy" src={campaign?.image} />
                <div className="od-home__latest-campaigns-details">
                  <h3>{campaign?.title}</h3>
                  {campaign?.description && index === 0 && <p>{campaign?.description}</p>}
                  <span>VIEW MORE</span>
                </div>
              </li>
            ))}
          </ul>
        )}
        <div className="od-home__latest-campaigns-btn">
          <a className="owndays-btn owndays-btn--secondary" href="/sg/en/news">
            VIEW MORE
          </a>
        </div>
      </div>
    </div>
  );
};

export default LatestCampaigns;
